module.exports = __webpack_public_path__ + "static/media/logo.1e5a7a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo.png
// module id = 858
// module chunks = 0